// The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work.

import React, { useState } from "react";
import Header from "../../component/_elements/Header.tsx";
import { useOutletContext } from "react-router-dom";
import { OutletContextType } from "../../types/GlobalType";

const Admin: React.FC = () => {
  const { isDarkMode, setIsDarkMode } = useOutletContext<OutletContextType>();
  const [currentYear, setCurrentYear] = useState("2025 - 2026");
  const [isYearDropdownOpen, setIsYearDropdownOpen] = useState(false);
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };
  const toggleYearDropdown = () => {
    setIsYearDropdownOpen(!isYearDropdownOpen);
  };
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isEditingPersonalInfo, setIsEditingPersonalInfo] = useState(false);
  const [personalInfo, setPersonalInfo] = useState({
    firstName: "Alexandre",
    lastName: "Martin",
    email: "alexandre.martin@chiksoft.edu",
    address: "123 Rue de l'Éducation, 75001 Paris, France",
    phone: "+33 1 23 45 67 89",
  });
  const [editedPersonalInfo, setEditedPersonalInfo] = useState({
    ...personalInfo,
  });
  const [profileModalData, setProfileModalData] = useState({
    firstName: "Alexandre",
    lastName: "Martin",
    email: "alexandre.martin@chiksoft.edu",
    avatar: "",
  });
  const [selectedAvatar, setSelectedAvatar] = useState<File | null>(null);

  const toggleUserMenu = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };

  const openPasswordModal = () => {
    setIsPasswordModalOpen(true);
  };

  const closePasswordModal = () => {
    setIsPasswordModalOpen(false);
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
  };

  const handlePasswordChange = () => {
    console.log("Changement de mot de passe");
    closePasswordModal();
  };

  const openProfileModal = () => {
    setIsProfileModalOpen(true);
    setProfileModalData({
      firstName: personalInfo.firstName,
      lastName: personalInfo.lastName,
      email: personalInfo.email,
      avatar: "",
    });
  };

  const closeProfileModal = () => {
    setIsProfileModalOpen(false);
    setSelectedAvatar(null);
  };

  const handleProfileModalSave = () => {
    setPersonalInfo((prev) => ({
      ...prev,
      firstName: profileModalData.firstName,
      lastName: profileModalData.lastName,
      email: profileModalData.email,
    }));
    console.log("Profil sauvegardé:", profileModalData);
    closeProfileModal();
  };

  const handleEditPersonalInfo = () => {
    setIsEditingPersonalInfo(true);
    setEditedPersonalInfo({ ...personalInfo });
  };

  const handleSavePersonalInfo = () => {
    setPersonalInfo({ ...editedPersonalInfo });
    setIsEditingPersonalInfo(false);
    console.log("Informations personnelles sauvegardées:", editedPersonalInfo);
  };

  const handleCancelEditPersonalInfo = () => {
    setEditedPersonalInfo({ ...personalInfo });
    setIsEditingPersonalInfo(false);
  };

  const handlePersonalInfoChange = (field: string, value: string) => {
    setEditedPersonalInfo((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleProfileModalChange = (field: string, value: string) => {
    setProfileModalData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleAvatarChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedAvatar(file);
    }
  };

  const recentActivities = [
    {
      id: 1,
      action: "Connexion au système",
      timestamp: "2025-01-06 08:30:15",
      icon: "fas fa-sign-in-alt",
      color: "text-green-600",
    },
    {
      id: 2,
      action: "Modification des paramètres utilisateur",
      timestamp: "2025-01-05 16:45:22",
      icon: "fas fa-cog",
      color: "text-blue-600",
    },
    {
      id: 3,
      action: "Consultation des rapports",
      timestamp: "2025-01-05 14:20:10",
      icon: "fas fa-chart-bar",
      color: "text-purple-600",
    },
    {
      id: 4,
      action: "Gestion des utilisateurs",
      timestamp: "2025-01-04 11:15:33",
      icon: "fas fa-users",
      color: "text-orange-600",
    },
    {
      id: 5,
      action: "Sauvegarde des données",
      timestamp: "2025-01-04 09:00:00",
      icon: "fas fa-database",
      color: "text-indigo-600",
    },
  ];

  return (
    <div className="ml-60 w-full">
      {/* Header */}
      <Header
        isDarkMode={isDarkMode}
        setIsDarkMode={setIsDarkMode}
        toggleDarkMode={toggleDarkMode}
        currentYear={currentYear}
        isYearDropdownOpen={isYearDropdownOpen}
        toggleYearDropdown={toggleYearDropdown}
        setCurrentYear={setCurrentYear}
        setIsYearDropdownOpen={setIsYearDropdownOpen}
      />

      {/* Main Content */}
      <div className="p-6 mt-16">
        {/* Page Title */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Mon Profil</h1>
          <p className={`${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
            Gérez vos informations personnelles et paramètres de compte
          </p>
        </div>

        {/* Profile Main Section */}
        <div
          className={`${
            isDarkMode ? "bg-gray-800" : "bg-white"
          } rounded-xl shadow-lg p-8 mb-8`}
        >
          <div className="flex items-center space-x-6">
            <div className="w-24 h-24 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
              <span className="text-white text-2xl font-bold">AM</span>
            </div>
            <div className="flex-1">
              <h2 className="text-2xl font-bold mb-1">Alexandre Martin</h2>
              <p
                className={`${
                  isDarkMode ? "text-gray-400" : "text-gray-600"
                } mb-2`}
              >
                alexandre.martin@chiksoft.edu
              </p>
              <div className="flex items-center space-x-4">
                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                  <i className="fas fa-shield-alt mr-1"></i>
                  Administrateur
                </span>
                <span
                  className={`text-sm ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  }`}
                  onClick={openPasswordModal}
                >
                  <i className="fas fa-key mr-2"></i>{" "}
                  <span className="underline cursor-pointer">
                    Changer le mot de passe
                  </span>
                </span>
              </div>
            </div>
            <button
              onClick={openProfileModal}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 !rounded-button whitespace-nowrap cursor-pointer"
            >
              <i className="fas fa-edit mr-2"></i>
              Modifier le profil
            </button>
          </div>
        </div>

        {/* Detailed Information Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
          {/* Personal Information */}
          <div
            className={`${
              isDarkMode ? "bg-gray-800" : "bg-white"
            } rounded-xl shadow-lg p-6`}
          >
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-semibold">
                Informations Personnelles
              </h3>
              {!isEditingPersonalInfo ? (
                <button
                  onClick={handleEditPersonalInfo}
                  className="text-blue-600 hover:text-blue-700 cursor-pointer"
                >
                  <i className="fas fa-edit"></i>
                </button>
              ) : (
                <div className="flex space-x-2">
                  <button
                    onClick={handleSavePersonalInfo}
                    className="px-3 py-1 bg-green-600 text-white rounded-lg hover:bg-green-700 text-sm !rounded-button whitespace-nowrap cursor-pointer"
                  >
                    <i className="fas fa-check mr-1"></i>
                    Sauvegarder
                  </button>
                  <button
                    onClick={handleCancelEditPersonalInfo}
                    className={`px-3 py-1 ${
                      isDarkMode
                        ? "bg-gray-600 hover:bg-gray-700"
                        : "bg-gray-300 hover:bg-gray-400"
                    } rounded-lg text-sm !rounded-button whitespace-nowrap cursor-pointer`}
                  >
                    <i className="fas fa-times mr-1"></i>
                    Annuler
                  </button>
                </div>
              )}
            </div>
            <div className="space-y-4">
              <div>
                <label
                  className={`block text-sm font-medium ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  } mb-1`}
                >
                  Prénom
                </label>
                {!isEditingPersonalInfo ? (
                  <p className="text-lg">{personalInfo.firstName}</p>
                ) : (
                  <input
                    type="text"
                    value={editedPersonalInfo.firstName}
                    onChange={(e) =>
                      handlePersonalInfoChange("firstName", e.target.value)
                    }
                    className={`w-full px-3 py-2 rounded-lg border text-sm ${
                      isDarkMode
                        ? "bg-gray-700 border-gray-600 text-white"
                        : "bg-white border-gray-300"
                    }`}
                  />
                )}
              </div>
              <div>
                <label
                  className={`block text-sm font-medium ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  } mb-1`}
                >
                  Nom
                </label>
                {!isEditingPersonalInfo ? (
                  <p className="text-lg">{personalInfo.lastName}</p>
                ) : (
                  <input
                    type="text"
                    value={editedPersonalInfo.lastName}
                    onChange={(e) =>
                      handlePersonalInfoChange("lastName", e.target.value)
                    }
                    className={`w-full px-3 py-2 rounded-lg border text-sm ${
                      isDarkMode
                        ? "bg-gray-700 border-gray-600 text-white"
                        : "bg-white border-gray-300"
                    }`}
                  />
                )}
              </div>
              <div>
                <label
                  className={`block text-sm font-medium ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  } mb-1`}
                >
                  Email
                </label>
                {!isEditingPersonalInfo ? (
                  <p className="text-lg">{personalInfo.email}</p>
                ) : (
                  <input
                    type="email"
                    value={editedPersonalInfo.email}
                    onChange={(e) =>
                      handlePersonalInfoChange("email", e.target.value)
                    }
                    className={`w-full px-3 py-2 rounded-lg border text-sm ${
                      isDarkMode
                        ? "bg-gray-700 border-gray-600 text-white"
                        : "bg-white border-gray-300"
                    }`}
                  />
                )}
              </div>
              <div>
                <label
                  className={`block text-sm font-medium ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  } mb-1`}
                >
                  Adresse
                </label>
                {!isEditingPersonalInfo ? (
                  <p className="text-lg">{personalInfo.address}</p>
                ) : (
                  <textarea
                    value={editedPersonalInfo.address}
                    onChange={(e) =>
                      handlePersonalInfoChange("address", e.target.value)
                    }
                    rows={2}
                    className={`w-full px-3 py-2 rounded-lg border text-sm ${
                      isDarkMode
                        ? "bg-gray-700 border-gray-600 text-white"
                        : "bg-white border-gray-300"
                    } resize-none`}
                  />
                )}
              </div>
              <div>
                <label
                  className={`block text-sm font-medium ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  } mb-1`}
                >
                  Téléphone
                </label>
                {!isEditingPersonalInfo ? (
                  <p className="text-lg">{personalInfo.phone}</p>
                ) : (
                  <input
                    type="tel"
                    value={editedPersonalInfo.phone}
                    onChange={(e) =>
                      handlePersonalInfoChange("phone", e.target.value)
                    }
                    className={`w-full px-3 py-2 rounded-lg border text-sm ${
                      isDarkMode
                        ? "bg-gray-700 border-gray-600 text-white"
                        : "bg-white border-gray-300"
                    }`}
                  />
                )}
              </div>
            </div>
          </div>

          {/* Professional Information */}
          <div
            className={`${
              isDarkMode ? "bg-gray-800" : "bg-white"
            } rounded-xl shadow-lg p-6`}
          >
            <h3 className="text-xl font-semibold mb-6">
              Informations Professionnelles
            </h3>
            <div className="space-y-4">
              <div>
                <label
                  className={`block text-sm font-medium ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  } mb-1`}
                >
                  Rôle
                </label>
                <p className="text-lg">Administrateur Système</p>
              </div>
              <div>
                <label
                  className={`block text-sm font-medium ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  } mb-1`}
                >
                  Département
                </label>
                <p className="text-lg">Technologies de l'Information</p>
              </div>
              <div>
                <label
                  className={`block text-sm font-medium ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  } mb-1`}
                >
                  Permissions
                </label>
                <div className="flex flex-wrap gap-2">
                  <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">
                    Gestion complète
                  </span>
                  <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs">
                    Rapports
                  </span>
                  <span className="px-2 py-1 bg-purple-100 text-purple-800 rounded-full text-xs">
                    Utilisateurs
                  </span>
                </div>
              </div>
              <div>
                <label
                  className={`block text-sm font-medium ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  } mb-1`}
                >
                  Date d'embauche
                </label>
                <p className="text-lg">15 septembre 2020</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Password Change Modal */}
      {isPasswordModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
            className={`${
              isDarkMode ? "bg-gray-800" : "bg-white"
            } rounded-xl shadow-xl p-8 w-full max-w-md mx-4`}
          >
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-semibold">Changer le mot de passe</h3>
              <button
                onClick={closePasswordModal}
                className={`text-gray-400 hover:text-gray-600 cursor-pointer`}
              >
                <i className="fas fa-times text-xl"></i>
              </button>
            </div>
            <div className="space-y-4">
              <div>
                <label
                  className={`block text-sm font-medium ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  } mb-2`}
                >
                  Mot de passe actuel
                </label>
                <input
                  type="password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  className={`w-full px-4 py-3 rounded-lg border ${
                    isDarkMode
                      ? "bg-gray-700 border-gray-600 text-white"
                      : "bg-white border-gray-300"
                  } text-sm`}
                  placeholder="Entrez votre mot de passe actuel"
                />
              </div>
              <div>
                <label
                  className={`block text-sm font-medium ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  } mb-2`}
                >
                  Nouveau mot de passe
                </label>
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className={`w-full px-4 py-3 rounded-lg border ${
                    isDarkMode
                      ? "bg-gray-700 border-gray-600 text-white"
                      : "bg-white border-gray-300"
                  } text-sm`}
                  placeholder="Entrez votre nouveau mot de passe"
                />
              </div>
              <div>
                <label
                  className={`block text-sm font-medium ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  } mb-2`}
                >
                  Confirmer le nouveau mot de passe
                </label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className={`w-full px-4 py-3 rounded-lg border ${
                    isDarkMode
                      ? "bg-gray-700 border-gray-600 text-white"
                      : "bg-white border-gray-300"
                  } text-sm`}
                  placeholder="Confirmez votre nouveau mot de passe"
                />
              </div>
            </div>
            <div className="flex space-x-4 mt-8">
              <button
                onClick={closePasswordModal}
                className={`flex-1 px-4 py-3 ${
                  isDarkMode
                    ? "bg-gray-600 hover:bg-gray-700"
                    : "bg-gray-300 hover:bg-gray-400"
                } rounded-lg !rounded-button whitespace-nowrap cursor-pointer`}
              >
                Annuler
              </button>
              <button
                onClick={handlePasswordChange}
                className="flex-1 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 !rounded-button whitespace-nowrap cursor-pointer"
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Profile Edit Modal */}
      {isProfileModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
            className={`${
              isDarkMode ? "bg-gray-800" : "bg-white"
            } rounded-xl shadow-xl p-8 w-full max-w-lg mx-4`}
          >
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-semibold">Modifier le profil</h3>
              <button
                onClick={closeProfileModal}
                className="text-gray-400 hover:text-gray-600 cursor-pointer"
              >
                <i className="fas fa-times text-xl"></i>
              </button>
            </div>
            <div className="space-y-6">
              {/* Avatar Section */}
              <div className="flex flex-col items-center space-y-4">
                <div className="relative">
                  <div className="w-24 h-24 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
                    <span className="text-white text-2xl font-bold">AM</span>
                  </div>
                  <button
                    onClick={() =>
                      document.getElementById("avatar-input")?.click()
                    }
                    className="absolute bottom-0 right-0 bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center hover:bg-blue-700 cursor-pointer"
                  >
                    <i className="fas fa-camera text-sm"></i>
                  </button>
                  <input
                    id="avatar-input"
                    type="file"
                    accept="image/*"
                    onChange={handleAvatarChange}
                    className="hidden"
                  />
                </div>
                <p
                  className={`text-sm ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  } text-center`}
                >
                  Cliquez sur l'icône pour changer votre photo de profil
                </p>
                {selectedAvatar && (
                  <p className="text-sm text-green-600">
                    Photo sélectionnée: {selectedAvatar.name}
                  </p>
                )}
              </div>

              {/* Form Fields */}
              <div className="space-y-4">
                <div>
                  <label
                    className={`block text-sm font-medium ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    } mb-2`}
                  >
                    Prénom
                  </label>
                  <input
                    type="text"
                    value={profileModalData.firstName}
                    onChange={(e) =>
                      handleProfileModalChange("firstName", e.target.value)
                    }
                    className={`w-full px-4 py-3 rounded-lg border ${
                      isDarkMode
                        ? "bg-gray-700 border-gray-600 text-white"
                        : "bg-white border-gray-300"
                    } text-sm`}
                    placeholder="Entrez votre prénom"
                  />
                </div>
                <div>
                  <label
                    className={`block text-sm font-medium ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    } mb-2`}
                  >
                    Nom
                  </label>
                  <input
                    type="text"
                    value={profileModalData.lastName}
                    onChange={(e) =>
                      handleProfileModalChange("lastName", e.target.value)
                    }
                    className={`w-full px-4 py-3 rounded-lg border ${
                      isDarkMode
                        ? "bg-gray-700 border-gray-600 text-white"
                        : "bg-white border-gray-300"
                    } text-sm`}
                    placeholder="Entrez votre nom"
                  />
                </div>
                <div>
                  <label
                    className={`block text-sm font-medium ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    } mb-2`}
                  >
                    Adresse email
                  </label>
                  <input
                    type="email"
                    value={profileModalData.email}
                    onChange={(e) =>
                      handleProfileModalChange("email", e.target.value)
                    }
                    className={`w-full px-4 py-3 rounded-lg border ${
                      isDarkMode
                        ? "bg-gray-700 border-gray-600 text-white"
                        : "bg-white border-gray-300"
                    } text-sm`}
                    placeholder="Entrez votre adresse email"
                  />
                </div>
              </div>
            </div>
            <div className="flex space-x-4 mt-8">
              <button
                onClick={closeProfileModal}
                className={`flex-1 px-4 py-3 ${
                  isDarkMode
                    ? "bg-gray-600 hover:bg-gray-700"
                    : "bg-gray-300 hover:bg-gray-400"
                } rounded-lg !rounded-button whitespace-nowrap cursor-pointer`}
              >
                Annuler
              </button>
              <button
                onClick={handleProfileModalSave}
                className="flex-1 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 !rounded-button whitespace-nowrap cursor-pointer"
              >
                Sauvegarder
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Admin;
